import {DEFAULTS} from './useInventory';
import {InventoryFilterState} from '../../../../skin-db/database/filter/SkinDbFilter';

export const useInventoryFilters = (
    filters: InventoryFilterState,
    onUpdateFilters: (f: InventoryFilterState) => void,
    currencySymbol: string
) => {
  const safeSymbol = String(currencySymbol);

  const removeFilter = (key: keyof InventoryFilterState, valueToRemove?: any) => {
    const currentVal = filters[key];
    if (Array.isArray(currentVal)) {
      onUpdateFilters({
        ...filters,
        [key]: currentVal.filter((v) => v !== valueToRemove),
      });
    } else {
      const defaultValue =
          (DEFAULTS as any)[key] !== undefined
              ? (DEFAULTS as any)[key]
              : typeof currentVal === 'number'
                  ? 0
                  : '';
      onUpdateFilters({ ...filters, [key]: defaultValue });
    }
  };

  const getActiveChips = () => {
    const chips: { key: keyof InventoryFilterState; label: string; value?: any }[] = [];

    // Fix: Explicitly use String() for the currency symbol in labels
    if (filters.minPrice !== DEFAULTS.minPrice) chips.push({ key: 'minPrice', label: `${safeSymbol}${filters.minPrice}+` });
    if (filters.maxPrice !== DEFAULTS.maxPrice) chips.push({ key: 'maxPrice', label: `<${safeSymbol}${filters.maxPrice}` });

    if (filters.floatMin !== DEFAULTS.floatMin) chips.push({ key: 'floatMin', label: `F-Min: ${filters.floatMin}` });
    if (filters.floatMax !== DEFAULTS.floatMax) chips.push({ key: 'floatMax', label: `F-Max: ${filters.floatMax}` });
    if (filters.paintSeed !== null && String(filters.paintSeed) !== '') chips.push({ key: 'paintSeed', label: `Seed: ${filters.paintSeed}` });
    if (filters.minFade !== DEFAULTS.minFade) chips.push({ key: 'minFade', label: `Fade: ${filters.minFade}%+` });
    if (filters.maxFade !== DEFAULTS.maxFade) chips.push({ key: 'maxFade', label: `Fade: <${filters.maxFade}%` });
    if (filters.minBlue !== DEFAULTS.minBlue) chips.push({ key: 'minBlue', label: `Blue: ${filters.minBlue}%+` });
    if (filters.maxBlue !== DEFAULTS.maxBlue) chips.push({ key: 'maxBlue', label: `<${filters.maxBlue}%` });

    const arrayFilterKeys: (keyof InventoryFilterState)[] = [
      'exterior', 'rarity', 'extra', 'type', 'phase', 'rarePattern', 'unique',
      'pistols', 'smg', 'rifles', 'snipers', 'shotguns', 'machineguns', 'equipment', 'knives'
    ];

    arrayFilterKeys.forEach(key => {
      const val = filters[key];
      if (Array.isArray(val)) {
        val.forEach(item => chips.push({ key, label: String(item), value: item }));
      }
    });

    return chips;
  };

  return { activeChips: getActiveChips(), removeFilter };
};